import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import './onboarding.css';
var filterAvailableSteps = function (steps) {
    return steps.filter(function (step) {
        if (step.onHighlightStarted ||
            step.onHighlighted ||
            step.waitForElement ||
            !step.element) {
            return true;
        }
        if (typeof step.element === 'string') {
            return !!document.querySelector(step.element);
        }
        return true;
    });
};
export var runTour = function (steps, labels, onComplete) {
    var availableSteps = filterAvailableSteps(steps);
    if (availableSteps.length === 0) {
        onComplete();
        return;
    }
    var completed = false;
    var driverObj = driver({
        showProgress: true,
        progressText: labels.progress,
        nextBtnText: labels.next,
        prevBtnText: labels.prev,
        doneBtnText: labels.done,
        popoverClass: 'clinic-onboarding-popover',
        skipMissingElement: true,
        waitForElement: 2500,
        smoothScroll: false,
        allowScroll: true,
        overlayClickBehavior: 'nextStep',
        steps: availableSteps,
        onDestroyStarted: function () {
            if (!completed) {
                completed = true;
                onComplete();
            }
            driverObj.destroy();
        },
    });
    driverObj.drive();
};
